import React from "react";
import { Cuotas } from "../Promocion";
import { useAppSelector } from "../../../../../hooks/customReduxHooks";
import { useHandlerCDNMultimedia } from "../../../../../hooks/useHandlerCDNMultimedia";
import { PromocionMedioDePagoContainer, PriceContainer, } from "./PromocionMedioDePagoStyled";
export var PromocionMedioDePago = function (_a) {
    var descuentoPorMedioDePago = _a.descuentoPorMedioDePago, moneda = _a.moneda;
    var getS3Multimedia = useHandlerCDNMultimedia().getS3Multimedia;
    var empresaData = useAppSelector(function (state) { var _a; return (_a = state.empresa) === null || _a === void 0 ? void 0 : _a.empresaData; });
    var pmed_imagen = descuentoPorMedioDePago.pmed_imagen
        ? getS3Multimedia({
            path: "_img_pagos/".concat(descuentoPorMedioDePago.pmed_imagen),
            settings: empresaData.configuraciones,
        })
        : null;
    return (empresaData === null || empresaData === void 0 ? void 0 : empresaData.configuraciones) && (React.createElement(PromocionMedioDePagoContainer, null,
        React.createElement(PriceContainer, null,
            pmed_imagen ? (React.createElement("img", { src: pmed_imagen, alt: descuentoPorMedioDePago.pmed_nombre })) : (React.createElement("span", null,
                descuentoPorMedioDePago.pmed_nombre,
                ":")),
            React.createElement("b", null,
                moneda,
                " ",
                descuentoPorMedioDePago.precio_final_formateado)),
        React.createElement(Cuotas, { cuotas: descuentoPorMedioDePago.cantidad_de_cuotas })));
};
